import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

interface SLabelProps {
  asContainer?: boolean;
  info?: string;
  required?: boolean;
  isBeta?: boolean;
  labelClasses?: string;
  asColumns?: boolean;
  labelMaxWidth?: string;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SLabel',
  props: {
  asContainer: { type: Boolean, default: false },
  info: { default: '' },
  required: { type: Boolean, default: false },
  isBeta: { type: Boolean, default: false },
  labelClasses: { default: '' },
  asColumns: { type: Boolean, default: false },
  labelMaxWidth: { default: '' },
  disabled: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


const tag = props.asContainer ? 'div' : 'label';

const maxWidthStyle = _computed(() => (props.labelMaxWidth ? `max-width: ${props.labelMaxWidth}` : ''));

return { __sfc: true,props, tag, maxWidthStyle, _computed }
}

})